
import { Component, Prop, Vue } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import SubjectSelectButton from '@/components/organisms/SubjectSelectButton.vue'
import ColorCurriculumUnitBox from '@/components/organisms/ColorCurriculumUnitBox.vue'
import { LearningStatusCurriculumUnit, DailyUserReviewProblemCurriculumUnit } from '@/models/CurriculumUnit'
import { LearningProgress } from '@/const/LearningProgress'

/**
 * 今日やる問題パネル
 */
@Component({
  components: {
    PanelFrame,
    ColorCurriculumUnitBox,
    SubjectSelectButton,
  },
})
export default class DailyProblemPanel extends Vue {
  /** 今日やる問題一覧 */
  @Prop()
  private dailyProblemList!: DailyUserReviewProblemCurriculumUnit[] | null

  /** 項目ボックスクリック時のイベント */
  @Prop()
  private eventClickBox!: (curriculumUnitId: number) => void

  /**
   * 今日やる問題があるか(表示する問題があるか)判定
   *
   * @returns あればtrue
   */
  private get hasDailyProblem(): boolean {
    if (!this.dailyProblemList) {
      return false
    }
    return this.dailyProblemList.length > 0
  }

  /**
   * 今日やる問題一覧を学習状況付き単元一覧の型に成形する
   *
   * @returns 学習状況付き単元一覧
   */
  private get dailyProblemCurriculumUnits(): LearningStatusCurriculumUnit[] {
    if (!this.dailyProblemList) {
      return []
    }
    return this.dailyProblemList.map((problem) => {
      return {
        id: problem.id,
        name: problem.name,
        learningProgress: LearningProgress.findByLevel(problem.level),
      }
    })
  }
}
